import { Button } from "common/buttons";
import { Box } from "common/components/Box";
import React from "react";

interface Props {
  score: number;
  resetForm: () => void;
  summaryText?: string;
  showNextElementButton?: boolean;
  onNextElementClick?: () => void;
}

function getPercentageFromScore(score: number): number {
  return Number((score * 100).toFixed(1));
}

export const Result: React.FC<React.PropsWithChildren<Props>> = ({
  score,
  resetForm,
  summaryText = "Din poengscore ble",
  showNextElementButton = false,
  onNextElementClick,
}) => {
  return (
    <Box centeredContent>
      <p>
        {summaryText} {getPercentageFromScore(score)}% riktig!
      </p>
      <span>
        <Button
          kind={showNextElementButton ? "secondary" : "primary"}
          onClick={resetForm}
        >
          Prøv på nytt
        </Button>
        {showNextElementButton && (
          <Button onClick={onNextElementClick}>Gå videre</Button>
        )}
      </span>
    </Box>
  );
};
